// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container-fluid[data-v-ec3b9d18]{min-height:200px}.container-fluid .quizOption[data-v-ec3b9d18]{width:100%}", ""]);
// Exports
module.exports = exports;
